import { IconClose } from '@consta/icons/IconClose'
import { Button } from '@consta/uikit/Button'
import { Text } from '@consta/uikit/Text'
import { LogoIcon } from '@library/components'
import type { FC } from 'react'

import { Header } from '../../Header'
import css from './SidebarHeader.css'

type SidebarHeaderProps = { projectName: string; handleClose: VoidFunction }

export const SidebarHeader: FC<SidebarHeaderProps> = ({ projectName, handleClose }) => {
  return (
    <Header className={css.header}>
      <Header.LeftBlock>
        <LogoIcon />
        <Text className={css.text} size="xs" view="primary" truncate={true}>
          {projectName}
        </Text>
      </Header.LeftBlock>
      <Header.RightBlock>
        <Button
          view="clear"
          iconLeft={IconClose}
          size="xs"
          onlyIcon={true}
          label="Закрыть сайдбар"
          onClick={handleClose}
        />
      </Header.RightBlock>
    </Header>
  )
}
